import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

export const useStyles = makeStyles((theme: ITheme) => ({
  bar: {
    backgroundColor: colors.gainsboro,
    height: 53,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: 8,
    paddingLeft: 17,
    paddingRight: 17,
  },
}));
